export default __webpack_public_path__ + "images/baedf009bb329458ae80eb599fb8a4d5-3_tablet_1067x470.jpg";